let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iphUq")).then(() => parcelRequire('7i1h4'));